module.exports = __webpack_public_path__ + "media/tips.f0e50a0c.wav";